import _ from "lodash";
import { useMemo } from "react";
import { useLeadStore } from "..";
import useLeadsWithFocusArea from "./useLeadsWithFocusArea";
import useLeadsWithGlobalFilters from "./useLeadsWithGlobalFilters";

export default function () {
    const leadStore = useLeadStore();
    const leads = useLeadsWithFocusArea(useLeadsWithGlobalFilters(leadStore.leads));

    return useMemo(() => {
        const availableOwners = _.sortBy(_.uniq(leads.filter(l => l.modifiedByUser).map(l => l.modifiedByUser!)));

        return ["All Owners", "None"].concat(availableOwners);
    }, [leads]);
}